import { memo, useCallback } from "react";
import { useAppDispatch, useAppSelector } from "stores";
import { appStateMutate } from "stores/modules/app.state/operations";
import {
  getRoomSavedataByOrder,
  getRoomSavedataIdByOrder,
} from "stores/modules/entities.room.savedatas/selectors";
import styled from "styled-components";
import SavedataItem from "./SavedataItem";
import { getAppState } from "stores/modules/app.state/selectors";
import { getCurrentRoom } from "stores/modules/entities.rooms/selectors";

const SavedataList = () => {
  return (
    <Savedatas>
      <SavedataContainer slot={0} />
      <SavedataContainer slot={1} />
      <SavedataContainer slot={2} />
    </Savedatas>
  );
};

type SavedataContainerProps = {
  slot: number;
};

const SavedataContainer = ({ slot }: SavedataContainerProps) => {
  const savedataId = useAppSelector((state) =>
    getRoomSavedataIdByOrder(state, slot)
  );
  const savedata = useAppSelector((state) =>
    getRoomSavedataByOrder(state, slot)
  );
  const saving = useAppSelector(
    (state) => getAppState(state, "slotNumberProcessingSave") === slot
  );
  const isProductRoom = useAppSelector(
    (state) => getCurrentRoom(state)?.parentProductId != null
  );

  const dispatch = useAppDispatch();
  const handleClick = useCallback(() => {
    dispatch(
      appStateMutate((state) => {
        state.openSaveConfirm = slot;
        state.saveConformDisabledNameEdit = false;
      })
    );
  }, [slot, dispatch]);

  const handleDelete = useCallback(() => {
    if (savedataId) {
      dispatch(
        appStateMutate((state) => {
          state.openDeleteSavedataConfirm = true;
          state.openDeleteSavedataConfirmId = savedataId;
        })
      );
    }
  }, [savedataId, dispatch]);

  const onDelete = savedata == null ? undefined : handleDelete;
  const name = savedata == null ? "NODATA" : savedata.name;

  return (
    <SavedataItem
      thumbnail={savedata?.thumbnail}
      name={name}
      updatedAt={isProductRoom ? undefined : savedata?.updatedAt}
      loading={saving}
      onClick={handleClick}
      onDelete={onDelete}
    />
  );
};

const Savedatas = styled.div`
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  ::-webkit-scrollbar: {
    display: none;
  }
`;

export default memo(SavedataList);
